<div class="chart-control">
  <div [ngClass]="rawChartData?'panel-main-chart':''">
    <app-multi-year-timeseries-chart #theChart
                                     [chartSeries]="rawChartData"
                                     [focusYear]="focusYear"
                                     [timePeriod]="timePeriod"
                                     [chartHeight]="expanded?400:200"
                                     [annualTransform]="overlaySelection?.flattened?.aggregation"
                                     [chartLabel]="chartPolygonLabel"
                                     [expandable]="true"
                                     [downloadTimestep]="dataTimestep"
                                     [chartMode]="chartMode"
                                     (chartCleared)="userClearedChart()"
                                     (chartExpanded)="expand()">

    </app-multi-year-timeseries-chart>
  </div>
  <div *ngIf="rawChartData">
    <p><i>{{chartDescription}}</i></p>
  </div>
  <div *ngIf="!rawChartData" class="chart-placeholder">
    <div class="alert alert-info">
      <i class="fa fa-line-chart"></i>
      {{chartPrompt[selectionMode]}}
    </div>
  </div>
  <div *ngIf="!rawChartData&&chartError" class="chart-placeholder">
    <div class="alert alert-warning">
      <i class="fa fa-line-chart"></i>
      {{chartError}}
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="btn-group btn-group-toggle">
        <button type="button" class="btn btn-secondary"
                [ngbPopover]="chartTypePopover"
                ngbTooltip="Select diferent chart types"
                #popRef="ngbPopover">
          <i class="fa fa-bar-chart"></i>
        </button>
        <button type="button" class="btn btn-secondary"
                [ngbPopover]="featureSelectionPopover"
                ngbTooltip="Switch between point, region and hand drawn selection"
                #popRef="ngbPopover">
          <i class="fa fa-map-marker"></i>
        </button>
        <button type="button" class="btn btn-secondary" (click)="downloadData()"
                ngbTooltip="Download chart data in CSV format">
          <i class="fa fa-download"></i>
        </button>
        <button type="button" class="btn btn-secondary" (click)="downloadChart()"
                ngbTooltip="Download chart in PNG format">
          <i class="fa fa-file-image-o"></i>
        </button>
        <button class="btn btn-sm btn-secondary"
                ngbTooltip="Switch to global view"
                [disabled]="!selectedFeature"
                (click)="userClearedChart()"><i class="fa fa-globe"></i></button>
        <button *ngIf="allowExpand" type="button" class="btn btn-secondary" (click)="expand()">
          <i class="fa" [ngClass]="expanded?'fa-compress':'fa-expand'"></i>
        </button>
      </div>
  </div>
</div>

<!--
<ng-template #popupChart let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">
      {{chartPolygonLabel}}</h4>
    <button type="button" class="btn btn-secondary close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <app-multi-year-timeseries-chart #theChartPopout
                                     [chartSeries]="rawChartData"
                                     [focusYear]="focusYear"
                                     [chartHeight]="expandedChartHeight"
                                     [summableVariable]="overlaySelection?.flattened?.summable"
                                     [chartLabel]="chartPolygonLabel"
                                     [expandable]="false"
                                     [downloadTimestep]="dataTimestep"
                                     [chartMode]="chartMode"
                                     (chartCleared)="userClearedChart()">

    </app-multi-year-timeseries-chart>
  </div>
  <div class="modal-footer">
    <button autofocus type="button" class="btn btn-secondary" (click)="c('Close click')">Close</button>
  </div>
</ng-template>
-->

<ng-template #chartTypePopover>
  <div class="row">
    <div class="col-12">
      <!-- refactor the select to button style radio as for featureSelectionPopover -->
      <!-- <select [(ngModel)]="chartMode"
              id="chartModeSelect"
              (ngModelChange)="chartModeChanged()"
              class="form-control form-control-sm">
        <option *ngFor="let cm of chartModes" [ngValue]="cm">{{cm}}</option>
      </select> -->
      <div class="btn-group btn-group-toggle flex-sm-wrap"
           ngbRadioGroup
           name="chartTypeSelection"
           [(ngModel)]="chartMode"
           (change)="_chartModeChanged()">
        <label *ngFor="let cm of chartModes" ngbButtonLabel ="'chartMode_' + cm"
               [ngClass]="(chartMode===cm)?'btn-primary':'btn-secondary'">
          <input ngbButton  type="radio"
                 id="chartMode_{{cm}}"
                 name="chartMode"
                 [value]="cm">
          {{cm}}
        </label>
    </div>
    </div>
  </div>
</ng-template>


<ng-template #featureSelectionPopover>
  <div class="feature-selection-popover">
    <div class="chart-type-popover">
      <div class="row">
        <div class="col-12">
          <div class="btn-group btn-group-toggle flex-sm-wrap"
              *ngIf="overlaySelection.layer"
              ngbRadioGroup
              name="polygonSelection"
              [(ngModel)]="selectionMode"
              (ngModelChange)="featureSelectionModeChanged()">
            <label *ngFor="let mode of allPolygonModes" ngbButtonLabel [ngClass]="(selectionMode===mode)?'btn-primary':'btn-secondary'">
              <input ngbButton type="radio" [value]="mode" [disabled]="!validSelectionModes[mode]">{{shortLabel[mode]}}
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
